/* eslint-disable */
import React from 'react';
import Button from '@mui/material/Button';
import PaymentIcon from '@mui/icons-material/Payment';
import { useAuth } from '../context/AuthContext';

// ─────────────────────────────────────────────────────────────────────────────
// Lemon Squeezy checkout URL
// Configure success/cancel URLs inside your Lemon Squeezy dashboard:
//   Store → Settings → Checkout → Redirect URLs
// ─────────────────────────────────────────────────────────────────────────────

const LEMONSQUEEZY_CHECKOUT_URL =
  'https://myif.lemonsqueezy.com/checkout/buy/fe7a6c81-bf33-4ccd-af3f-dba175b8bef5';

const SUCCESS_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3002/success'
    : 'https://voicetyping.xyz/success';

const CANCEL_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3002/dashboard/payment'
    : 'https://voicetyping.xyz/dashboard/payment';

// ─────────────────────────────────────────────────────────────────────────────

export default function PayWithLemonSqueezy() {
  const { currentUser } = useAuth();

  const handlePayment = () => {
    const url = new URL(LEMONSQUEEZY_CHECKOUT_URL);

    // Prefill email if user is logged in
    if (currentUser?.email) {
      url.searchParams.set('checkout[email]', currentUser.email);
    }

    // Pass success/cancel redirect URLs to Lemon Squeezy
    url.searchParams.set('checkout[success_url]', SUCCESS_URL);
    url.searchParams.set('checkout[cancel_url]', CANCEL_URL);

    // Pass custom data (available in webhooks)
    if (currentUser?.email) {
      url.searchParams.set('checkout[custom][user_email]', currentUser.email);
    }

    window.location.href = url.toString();
  };

  return (
    <div style={{ width: '100%' }}>
      <Button
        onClick={handlePayment}
        variant="contained"
        fullWidth
        size="large"
        startIcon={<PaymentIcon />}
        sx={{
          py: 1.75,
          fontWeight: 700,
          fontSize: '1rem',
          textTransform: 'none',
          borderRadius: '8px',
          background: 'linear-gradient(135deg, #117A48 0%, #20B26B 100%)',
          boxShadow: '0 4px 14px rgba(32, 178, 107, 0.4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #0B4F32 0%, #117A48 100%)',
            boxShadow: '0 6px 20px rgba(32, 178, 107, 0.5)',
            transform: 'translateY(-1px)',
          },
          transition: 'all 0.2s ease',
        }}
      >
        Pay Now — ₹1050 (Lifetime)
      </Button>

      <p style={{ textAlign: 'center', fontSize: '11px', color: '#888', marginTop: '8px' }}>
        Secured by Lemon Squeezy · One-time payment · No subscription
      </p>
    </div>
  );
}
